import { SalesStage, FinalStatusSalesStages } from '../../Model/Lead';

const TRYRAZ_DASHBOARD_URL = 'https://dashboard.tryraz.com';

const SalesStagesOptions = {
  NEW_LEADS: 'NEW_LEADS',
  FIRST_MESSAGE: 'FIRST_MESSAGE',
  SECOND_MESSAGE: 'SECOND_MESSAGE',
  IN_DIALOGUE: 'IN_DIALOGUE',
  CALENDLY_SCHEDULED: 'CALENDLY_SCHEDULED',
  MANUAL: 'MANUAL',
  FOLLOW_UP: 'FOLLOW_UP',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  FINAL_STATUS: 'FINAL_STATUS',
  ALL: 'ALL',
};

const salesStagesFilterChecks = {
  [SalesStagesOptions.ALL]: () => true,
  [SalesStagesOptions.NEW_LEADS]: ({ salesStage }) => SalesStage.NEW_LEAD === salesStage,
  [SalesStagesOptions.FIRST_MESSAGE]: ({ salesStage }) => SalesStage.FIRST_MESSAGE === salesStage,
  [SalesStagesOptions.SECOND_MESSAGE]: ({ salesStage }) => SalesStage.SECOND_MESSAGE === salesStage,
  [SalesStagesOptions.IN_DIALOGUE]: ({ salesStage }) => SalesStage.IN_DIALOGUE === salesStage,
  [SalesStagesOptions.DUPLICATE]: ({ salesStage }) => SalesStage.DUPLICATE === salesStage,
  [SalesStagesOptions.MANUAL]: ({ salesStage }) => SalesStage.MANUAL === salesStage,
  [SalesStagesOptions.FOLLOW_UP]: ({ salesStage }) => salesStage === SalesStage.FOLLOW_UP,
  [SalesStagesOptions.PAYMENT_PENDING]: ({ salesStage }) => salesStage === SalesStage.PAYMENT_PENDING,
  [SalesStagesOptions.CALENDLY_SCHEDULED]: ({ salesStage }) => SalesStage.CALENDLY_SCHEDULED === salesStage,
  [SalesStagesOptions.FINAL_STATUS]: ({ salesStage }) => FinalStatusSalesStages.includes(salesStage),
};

const createTryRazContact = async (remote, leadId) => {
  try {
    const response = await remote('createContact', { leadId });
    const { success, error } = await response.json();
    return { success, error };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

const claimLead = async (remote) => {
  try {
    const response = await remote('claimLead', null, { method: 'GET' });
    const result = await response.json();
    return { success: response.ok, ...result };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

const getTryRazConversationLink = (contactNo) => (
  `${TRYRAZ_DASHBOARD_URL}/conversations?id=${encodeURIComponent(contactNo)}`
);

/**
 * Cancels a Cal.com meeting
 * @param {object} remote - The remote object
 * @param {string} leadId - The lead ID
 * @returns {Promise<Object>} - The response data from the remote call
 */
const cancelCalDotComMeeting = async (remote, leadId, reason, userName) => {
  try {
    const response = await remote('cancelMeeting', { leadId, reason, userName }, { method: 'POST' });
    const { success, error } = await response.json();
    return { success, error: error?.error?.message || error?.message || error };
  } catch (error) {
    return { success: false, error: error?.error?.message || error?.message || error };
  }
};

export {
  SalesStagesOptions,
  salesStagesFilterChecks,
  FinalStatusSalesStages,
  createTryRazContact,
  claimLead,
  getTryRazConversationLink,
  cancelCalDotComMeeting,
};
